import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMegaphone12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconMegaphone12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M8.47 1.054a1 1 0 0 1 1.53.848v7.196a1 1 0 0 1-1.53.848L5.357 8H5v2a1 1 0 0 1-1 1H2.924a1 1 0 0 1-.987-.836l-.368-2.21A2 2 0 0 1 0 6V5a2 2 0 0 1 2-2h3.357zM4 8v2H2.924L2.59 8zm1.5-1H5V4h.643l.122-.076L9 1.902v7.196L5.765 7.076 5.643 7zM2 4h2v3H2a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1m9 0v3a.5.5 0 0 0 1 0V4a.5.5 0 0 0-1 0"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMegaphone12);
